import PolicyDetailContainer from './PolicyDetailContainer';
export default PolicyDetailContainer;
